
import { fetchExperimentData, getAmplitudeValueForCampaign, getVariationIdentifierForCampaignKey, getVariationNameForCampaign, setUserPropertyValueInAmplitude } from "./sdkManager";

/*
 * This function initializes the SDK based on the provided type and requestInfo.
 *
 * @param {string} type - The type of SDK to initialize (e.g., 'dev', 'prod').
 * @param {object} requestInfo - The request information for initializing the SDK.
 * @returns {void}
*/
export function launchXlabsSdk(type, requestInfo) {
  // Initialize SDK
  fetchExperimentData(type, requestInfo);
}

export function getVariationNameForCampaignKey(workspaceId, campaignKey) {
  return getVariationNameForCampaign(workspaceId, campaignKey);
}

export function getVariationIdForCampaignKey(workspaceId, campaignKey) {
  return getVariationIdentifierForCampaignKey(workspaceId, campaignKey);
}

export function getAmplitudeValueForCampaignKey(workspaceId, campaignKey) {
  return getAmplitudeValueForCampaign(workspaceId, campaignKey);
}

export function setUserPropertyInAmplitude(workspaceId, campaignKey) {
  return setUserPropertyValueInAmplitude(workspaceId, campaignKey);
}